import { render, staticRenderFns } from "./BusMitig.vue?vue&type=template&id=ccb172e6"
import script from "./BusMitig.vue?vue&type=script&lang=js"
export * from "./BusMitig.vue?vue&type=script&lang=js"
import style0 from "./BusMitig.vue?vue&type=style&index=0&id=ccb172e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports